import { BaseAnonymousView } from '@/views/anonymous';
import { Error403View, Error404View, Error50xView, ErrorUnknownView } from '@/views/anonymous/errors';

import authRoutes from './auth';

export default [
  {
    path: '/',
    name: 'app_default',
  },
  {
    name: 'app_base_anonymous',
    component: BaseAnonymousView,
    meta: { redirectAuthenticatedUsers: true },
    children: [
      ...authRoutes,
    ],
  },
  {
    path: '/:notFound(.*)',
    name: 'app_not_found',
    component: Error404View,
    meta: { title: 'Page Not Found' },
  },
  {
    path: '/access-denied',
    name: 'app_forbidden',
    component: Error403View,
    meta: { title: 'Access Denied' },
  },
  {
    path: '/server-error',
    name: 'app_server_error',
    component: Error50xView,
    meta: { title: 'Server Error' },
  },
  {
    path: '/unknown-error',
    name: 'app_unknown_error',
    component: ErrorUnknownView,
    meta: { title: 'Unknown Error' },
  },
];
